var map = {
	"./aws.png": "./src/assests/images/aws.png",
	"./bauddhikgeeks.png": "./src/assests/images/bauddhikgeeks.png",
	"./buld.jpg": "./src/assests/images/buld.jpg",
	"./contact-tranhamduong.jpg": "./src/assests/images/contact-tranhamduong.jpg",
	"./deeplearning.png": "./src/assests/images/deeplearning.png",
	"./deeplearning2.png": "./src/assests/images/deeplearning2.png",
	"./fujinet.jpg": "./src/assests/images/fujinet.jpg",
	"./gdg.png": "./src/assests/images/gdg.png",
	"./github.png": "./src/assests/images/github.png",
	"./google.png": "./src/assests/images/google.png",
	"./googleAssistant.jpg": "./src/assests/images/googleAssistant.jpg",
	"./google_logo.png": "./src/assests/images/google_logo.png",
	"./ibm.png": "./src/assests/images/ibm.png",
	"./iig.png": "./src/assests/images/iig.png",
	"./ino.png": "./src/assests/images/ino.png",
	"./kong.png": "./src/assests/images/kong.png",
	"./localguide.gif": "./src/assests/images/localguide.gif",
	"./localguide.png": "./src/assests/images/localguide.png",
	"./logo_uit.png": "./src/assests/images/logo_uit.png",
	"./mlh-logo.png": "./src/assests/images/mlh-logo.png",
	"./mlh-logo.svg": "./src/assests/images/mlh-logo.svg",
	"./muahexanh.png": "./src/assests/images/muahexanh.png",
	"./siu.jpg": "./src/assests/images/siu.jpg",
	"./siuailab.jpg": "./src/assests/images/siuailab.jpg",
	"./skillenza.png": "./src/assests/images/skillenza.png",
	"./toeic.png": "./src/assests/images/toeic.png",
	"./ucsandiego.png": "./src/assests/images/ucsandiego.png",
	"./up.png": "./src/assests/images/up.png",
	"./vccorp.jpg": "./src/assests/images/vccorp.jpg",
	"./vng.jpg": "./src/assests/images/vng.jpg",
	"./xuantinhnguyen.png": "./src/assests/images/xuantinhnguyen.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assests/images sync recursive ^\\.\\/.*$";